<template>
  <div id="app">
    <Header />
    <router-view />
    <notifications group="foo" />
    <Footer />
    <Loader
      :spinnerType="'Spinners'"
      :color="'#3c91d9'"
      :height="64"
      :width="64"
      v-if="$store.state.isLoading && $store.state.activeBtn === null"
    />
  </div>
</template>
<script>
import Footer from "./components/Footer.vue";
import Header from "./components/Header.vue";
import Loader from "../components/Loader.vue";
export default {
  name: "app",
  components: {
    Header,
    Footer,
    Loader
  }
};
</script>